<template>
    <div>
        <div v-if="product.quantity > 0">
            <div class="detail-select" v-if="detailselect != false">
                <div v-for="variant in sortedVariants" v-if="variant.is_variant" class="items-wrapper clearfix" :class="{ variants_margin : canDisplayButtons }">
                    <p v-if="popup" class="select-text">{{ variant.variant_name }} <small v-if="variant.is_required" class="--requiredVariant">*</small></p>
                    <variant :variant="variant" :id="variant.id" :errors="variants.errors"></variant>
                </div>
            </div>
            <div class="buttons alert-continue-shopping" v-show="canDisplayButtons">
                <p v-if="product.quantity < 999">Dostupné množstvo <strong>{{ product.quantity }}ks</strong></p>
                <div>
                    <div class="btn blue-btn add-btn">
                        <div class="amount" v-bind:class="{ 'error' : quantity_error }" data-toggle="tooltip" :title="product.quantity < 1000 ? (product.quantity + 'ks max') : ''">
                            <input type="number" min="1" @focus="focusQuantity" class="form-control prevent" v-model="quantity">
                            <span @click="minusNumber" :class="{ disabled : quantity <= 1 }" class="prevent minus">-</span>
                            <span @click="plusNumber" :class="{ disabled : quantity >= product.quantity }" class="prevent plus">+</span>
                        </div>

                        <span @click="addToBasket">{{ _('Pridať do košíka') }}</span>
                    </div>
                    <button @click="fastBuy" class="btn view-btn">{{ _('Objednať zrýchlene') }}</button>
                </div>
            </div>
        </div>
        <div class="empty-product" v-else>
            {{ _('Ľutujeme, no tento produkt je momentálne nedostupný.') }}
        </div>
    </div>
</template>

<script>
    import Variant from './Variant.vue';

    export default {
        components : { Variant },

        props : ['productjson', 'otherdatajson', 'popup', 'detailselect', 'openmodalvariants'],

        data(){
            var product = JSON.parse(this.productjson),
                otherdata = JSON.parse(this.otherdatajson||'{}');

            return {
                product : product,
                otherdata : otherdata,

                canAddToBasket : true,

                quantity : (otherdata||{}).quantity||1,
                quantity_error : false,

                /*
                 * Products orders
                 */
                 variants : {
                    data : product.variants,
                    items : {},
                 },
            };
        },

        watch: {
            quantity(){
                this.quantity_error = false;

                var int = parseInt(this.quantity);

                if ( int <= 0 || isNaN(int) )
                {
                    this.quantity = 1;
                }
            },
            canDisplayButtons(value){
                if ( value == false ){
                    return;
                }

                this.$nextTick(() => {
                    $('.alert-text').animate({
                        scrollTop: $('.alert-continue-shopping').offset().top - 200,
                    }, 500);
                });
            }
        },

        computed: {
            variantsWithIds(){
                let data = [];

                for ( var key in this.variants.data ){
                    let obj = this.variants.data[key];
                        obj.id = key;

                    data.push(obj);
                };

                return data;
            },
            sortedVariants(){
                var data = this.variantsWithIds;

                return data.sort((a, b) => {
                    return b._order - a._order;
                });
            },
            canDisplayButtons(){
                let data = _.cloneDeep(Object.values(this.variantsWithIds));

                var variants = [].concat(data).filter(item => {
                    return item.is_variant == true && item.is_multiple == false;
                });

                var multipleVariants = [].concat(data).filter(item => {
                    return item.is_variant == true && item.is_multiple == true;
                });

                //If is not opened modal, or any variant
                if ( this.popup !== true || variants.length == 0 || multipleVariants.length > 0 ) {
                    return true;
                }

                let requiredVariants = _.sortBy(
                    variants.filter(item => item.is_required)
                            .map(item => parseInt(item.id))
                            .filter(id => id)
                );

                let selectedVariants = Object.keys(this.variants.items).map(id => parseInt(id));

                //Required variant is not selected
                for ( var k in requiredVariants ){
                    if ( selectedVariants.indexOf(requiredVariants[k]) === -1 ){
                        return false;
                    }
                }

                return true;
            }
        },

        methods: {
            plusNumber(){
                if ( this.quantity < this.product.quantity )
                    this.quantity += 1;
                else
                    this.quantity = this.product.quantity;
            },
            minusNumber(){
                if ( this.quantity > this.product.quantity )
                    this.quantity = this.product.quantity;
                else if ( this.quantity > 1 )
                    this.quantity -= 1;

            },
            focusQuantity(e){
                e.target.select();
            },
            fixVariants(variants){
                for ( var key in variants ) {
                    for ( var k in variants[key] ) {
                        variants[key][k] = variants[key][k].name;
                    }
                }

                return variants;
            },
            addToBasket(callback){
                let orderableVariants = Object.values(this.variants.data).filter(item => (
                    item.is_variant == true
                ));

                if ( this.openmodalvariants == true && orderableVariants.length != 0 ){
                    this.$root.setMessage(
                        'Vyberte prosím variantu produktu.', 'empty', 'add-to-basket',
                        JSON.stringify(this.product),
                        null,
                        JSON.stringify({
                            quantity : this.quantity,
                        }),
                    );
                    return;
                }

                this.canAddToBasket = true;

                window.eventHub.$emit('check-error');

                if ( !this.canAddToBasket )
                    return false;

                //If is no products available for order
                if ( parseInt(this.quantity) > parseInt(this.product.quantity) ){
                    this.quantity_error = true;
                    this.$root.setMessage(window.Laravel.trans.basket.overlimit);

                    return false;
                }

                let variantsFixed = this.fixVariants(this.variants.items);

                //Save product into basket in session
                $.post(window.Laravel.requests.basket.store, {
                    product_id : this.product.id, quantity : this.quantity,
                    variants : variantsFixed
                }, function(response){
                    if ( response.error ){
                        this.$root.setMessage(response.error, 'error');
                        return;
                    }

                    this.$root.basket = response;

                    for ( var key in response )
                        if ( response[key].product.id = this.product.id ){
                            this.$root.basket[key].quantity = response[key].quantity;
                        }

                    if ( typeof callback == 'function' ) {
                        callback.call();
                    }
                }.bind(this));

                //Facebook pixels event
                fbq('track', 'AddToCart', {
                    value: parseFloat(this.product.price * this.quantity),
                    currency: 'EUR',
                    content_type : 'product',
                    content_name : this.product.name,
                    content_ids : [this.product.id]
                });

                //If is fast buy
                if ( typeof callback == 'function' )
                    return true;

                this.product.quantity -= parseInt(this.quantity);

                this.quantity = 1;

                if ( typeof callback != 'function' )
                    this.$root.setMessage(window.Laravel.trans.basket.success, 'empty', 'basket-buttons');

                return true;
            },
            fastBuy(){
                this.addToBasket(function(){
                    window.location.href = window.Laravel.requests.basket.billingInformaiton;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.--requiredVariant {
    color: red;
}
</style>